import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  TAddParameterRules,
  TAllParametersRulesArray,
  TAllParametersRulesObj,
  TCategoryWeights,
  TCompositionsData,
} from "../types/eiskEngine";

export type RuleMode = "add" | "edit" | "delete" | null;

type TInitialState = {
  addParameterPanelStatus: boolean;
  addRulePanelStatus: boolean;
  categoryWeights: TCategoryWeights;
  getAllParametesRules: TAllParametersRulesObj[];
  activeCategoryTab: string;
  addParameterRuleData: TAddParameterRules;
  addEditParameterMode: string;
  selectedParameter: TAddParameterRules;
  deletedParametrId: number;
  refreshParametrsEntity: boolean;
  compositionsData: TCompositionsData | null;
  adjustedTargetParameters: TAddParameterRules[];
  addRuleForSelectedParam: TAllParametersRulesObj | null;
  selectedRuleIndex: number;
  ruleMode: RuleMode;
  openIndex: number[];
};

const initialState: TInitialState = {
  addParameterPanelStatus: false,
  addRulePanelStatus: false,
  categoryWeights: {
    financial: 25,
    transaction: 25,
    amid: 25,
    creditScore: 25,
  },
  getAllParametesRules: [],
  activeCategoryTab: "FIN",
  addParameterRuleData: {
    param_name: "",
    type: "",
    sub_type: "",
    desc: "",
    status: 1,
    rules: [],
    weight: 0,
    param_id: 0,
  },
  addEditParameterMode: "ADD",
  selectedParameter: {
    param_name: "",
    type: "",
    sub_type: "",
    desc: "",
    status: 0,
    rules: [],
    weight: 0,
    param_id: 0,
  },
  deletedParametrId: 0,
  refreshParametrsEntity: false,
  compositionsData: null,
  adjustedTargetParameters: [],
  addRuleForSelectedParam: null,
  selectedRuleIndex: 0,
  ruleMode: "add",
  openIndex: [],
};

export const riskEngineDetailsSlice = createSlice({
  name: "riskEngine",
  initialState: initialState,
  reducers: {
    // resetTradeDetails: (state) => {
    //   return {
    //     ...initialState,
    //   };
    // },

    setAddParameterPanelStatus: (state, action) => {
      state.addParameterPanelStatus = action.payload;
    },
    setAddRulePanelStatus: (state, action) => {
      state.addRulePanelStatus = action.payload;
    },
    updateCategoryWeight: (state, action) => {
      const { key, value } = action.payload;

      const category = state.compositionsData?.categories.find(
        (c) => c.category_name === key
      );

      if (category) {
        category.weight = Number(value);
      }
    },

    resetCategoryWeights: (state) => {
      state.compositionsData?.categories.forEach((category) => {
        category.weight = 25;
      });
    },
    setAllParametersRules: (
      state,
      action: PayloadAction<TAllParametersRulesObj[]>
    ) => {
      state.getAllParametesRules = action.payload;
    },
    setActiveCategoryTab: (state, action: PayloadAction<string>) => {
      state.activeCategoryTab = action.payload;
    },
    udpateAddParameterData: (
      state,
      action: PayloadAction<{
        addParameterRuleData: TAddParameterRules;
      }>
    ) => {
      state.addParameterRuleData = action.payload.addParameterRuleData;
    },
    resetParametersDetails: (state) => {
      state.addParameterRuleData = initialState.addParameterRuleData;
    },
    resetAddesRules: (state) => {
      state.addParameterRuleData.rules =
        initialState.addParameterRuleData.rules;
    },
    setParameterMode: (state, action: PayloadAction<string>) => {
      state.addEditParameterMode = action.payload;
    },
    setSelectedParameter: (
      state,
      action: PayloadAction<TAllParametersRulesObj>
    ) => {
      state.selectedParameter = action.payload;
    },
    setDeletedParameterId: (state, action: PayloadAction<number>) => {
      state.deletedParametrId = action.payload;
    },
    setRefreshParametrsEntity: (state) => {
      state.refreshParametrsEntity = !state.refreshParametrsEntity;
    },
    setCompositionsData: (state, action: PayloadAction<TCompositionsData>) => {
      state.compositionsData = action.payload;
    },
    setAdjustedTargetParameters: (
      state,
      action: PayloadAction<TAddParameterRules[]>
    ) => {
      state.adjustedTargetParameters = action.payload;
    },
    setAddRuleForSelectedParam: (
      state,
      action: PayloadAction<TAllParametersRulesObj>
    ) => {
      state.addRuleForSelectedParam = action.payload;
    },
    setSelectedRuleIndex: (state, action: PayloadAction<number>) => {
      state.selectedRuleIndex = action.payload;
    },
    setRuleMode: (state, action: PayloadAction<RuleMode>) => {
      state.ruleMode = action.payload;
    },
    setOpenIndex: (state, action: PayloadAction<number[]>) => {
      state.openIndex = action.payload;
    },
  },
});

export const {
  setAddParameterPanelStatus,
  setAddRulePanelStatus,
  updateCategoryWeight,
  resetCategoryWeights,
  setAllParametersRules,
  setActiveCategoryTab,
  udpateAddParameterData,
  resetParametersDetails,
  setParameterMode,
  setSelectedParameter,
  setDeletedParameterId,
  setRefreshParametrsEntity,
  setCompositionsData,
  setAdjustedTargetParameters,
  setAddRuleForSelectedParam,
  setSelectedRuleIndex,
  setRuleMode,
  setOpenIndex,
  resetAddesRules,
} = riskEngineDetailsSlice.actions;
export default riskEngineDetailsSlice.reducer;
